import loadjs from 'loadjs';
import { getModuleUrl, getVersionUrl } from './url';
import { getExperimentHash } from './experiments';
import { getGlobalVersion } from './globalVersions';
import { addLoader, findLoader } from './loadersRegistry';


/**
 * Wraps the loadjs script loader in promise and returns the promise
 * @param {String} id
 * @param {Object} currentVersion
 * @param {Boolean} isExp is this and Experimental Feature?
 * @return {Promise} resolves when the script is loaded
 */
export function scriptLoad(id, currentVersion, isExp) {
  if (__DEV__) {
    // This is useful when testing in dev, so i'm going to leave the console.log
    // eslint-disable-next-line no-console,no-inline-comments
    console.log('Load Script for:', id, currentVersion); // NOSONAR
  }

  const url = getModuleUrl(id, currentVersion, isExp);
  const existingLoader = findLoader(url);
  if (existingLoader) {
    return existingLoader;
  }

  const loadPromise = new Promise((resolve, error) => {
    loadjs(url, { success: () => resolve(id), error: () => error() });
  });

  addLoader(url, loadPromise);

  return loadPromise;
}

/**
 * Request the given module id versions and return it as promise
 * @param {String} id
 * @return {Promise} Resolves the json file
 */
export function versionLoad(id) {
  // If a global version is available return that
  const globalVersion = getGlobalVersion(id);
  if (globalVersion) {
    const versions = {
      latest: globalVersion,
      isExp: Boolean(globalVersion.isExp)
    };
    return Promise.resolve(versions);
  }

  return fetch(getVersionUrl(id)).
    then(response => response.json()).
    then(versions => {

      // Extend the latest version to include the experimental hash
      // and if the experiment is present
      return Promise.resolve({
        ...versions,
        latest: {
          ...versions.latest,
          version: getExperimentHash(id) || versions.latest.version
        },
        isExp: Boolean(getExperimentHash(id))
      }).catch(error => {
        throw new Error(
          `Error loading Script ${id}. Version not found. ${error}`
        );
      });
    });
}
